import { render, staticRenderFns } from "./ItemcategoryListing.vue?vue&type=template&id=3e206456&"
import script from "./ItemcategoryListing.vue?vue&type=script&lang=js&"
export * from "./ItemcategoryListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports